import { Box, Typography } from '@mui/material';
import React from 'react';
import styles from './StatusFlag.module.scss';

type Colors = 'gray' | 'red' | 'blue' | 'green';

export type StatusFlagProps = {
	status: string;
	color?: Colors;
	className?: string;
};

const getStatusClass = ( status: string ): Colors => {
	const grayStatuses = [ 'Draft' ];
	const redStatuses = [
		'Void',
		'Overdue',
		'Disputed'
	];
	const blueStatuses = [
		'Sent',
		'New',
		'Pending',
		'Partially Paid',
		'Awaiting Signers',
		'Refunding',
		'Countersign Ready',
	];
	if ( grayStatuses.includes( status ) ) {
		return 'gray';
	} else if ( redStatuses.includes( status ) ) {
		return 'red';
	} else if ( blueStatuses.includes( status ) ) {
		return 'blue';
	}
	return 'green';
};

const StatusFlag = ( props: StatusFlagProps ) => {
	const { status, color } = props;

	const statusClass = color ? color : getStatusClass( status );

	const className = [
		styles.flag,
		styles[ statusClass ],
		...( props.className ? [ props.className ] : [] ),
	].join( ' ' );

	return (
		<Box className={ className }>
			<Typography data-cy='statusFlag' className={ styles.text }>
				{ status }
			</Typography>
		</Box>
	);
};

export default StatusFlag;
